import { useTranslation } from 'react-i18next'

import { Caption1, Heading6 } from '@ui/Typography'
import { SortIcon } from '@ui/icons/Sort.icon'

import { Box } from '@shared/components/Box'

interface WidgetProps {
  title: string
  value?: number
  conversionRate?: number
  deviation?: number
  shouldRenderFooter?: boolean
}

export const Widget = ({
  title,
  value,
  conversionRate,
  deviation,
  shouldRenderFooter = true,
}: WidgetProps) => {
  const { t } = useTranslation()

  // it will be real condition which depends on deviation once BE will provide
  const tempCondition = Math.random() < 0.5

  return (
    <Box
      flex
      direction='column'
      justify='flex-start'
      gap='x4'
      p='x16'
      radius='x24'
      bg='surface-surface-1'
      border='outline-low-em'
    >
      <Caption1 color='text-med-em'>{title}</Caption1>
      <Box flex gap='x4' align='center'>
        <Heading6 semibold>{value || t('N/A')}</Heading6>
        {conversionRate && <Heading6 semibold>/</Heading6>}
        {conversionRate && (
          <Box flex direction='column'>
            <Caption1 semibold>{conversionRate}%</Caption1>
            <Caption1>{t('IB.Dashboard.CJM.Conversion rate')}</Caption1>
          </Box>
        )}
      </Box>
      {shouldRenderFooter && deviation && (
        <Box flex gap='x4' align='center'>
          <Box flex align='center'>
            <Caption1>
              {tempCondition ? (
                <SortIcon.Up color='text-success-high-em' />
              ) : (
                <SortIcon.Down color='text-danger-high-em' />
              )}
            </Caption1>
            <Caption1
              semibold
              color={tempCondition ? 'text-success-high-em' : 'text-danger-high-em'}
            >
              {deviation}
            </Caption1>
          </Box>
          <Caption1>{t('IB.Dashboard.CJM.Deviation description')}</Caption1>
        </Box>
      )}
    </Box>
  )
}
